import axios from 'axios';
import { useEffect, useState } from 'react';
import { Button } from '../../components/ui/button';
import { XIcon } from '@phosphor-icons/react';

const Banner = ({ onClose }) => {
  const [hellobars, setHellobars] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [timeLeft, setTimeLeft] = useState({});

  useEffect(() => {
    const isClosed = sessionStorage.getItem('hellobarClosed');
    if (isClosed) return;

    const fetchHellobars = async () => {
      try {
        const response = await axios.get('/api/hellobar/v2');
        setHellobars(response?.data?.hellobar);
      } catch (error) {
        console.error('Failed to fetch hellobar data:', error);
        setHellobars([]);
      }
    };

    fetchHellobars();
  }, []);

  useEffect(() => {
    if (hellobars?.length > 1) {
      const interval = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % hellobars?.length);
      }, 8000);

      return () => clearInterval(interval);
    }
  }, [hellobars]);

  useEffect(() => {
    if (hellobars?.length > 0) {
      const currentHellobar = hellobars[currentIndex];
      if (currentHellobar && currentHellobar.isTimerEnabled) {
        const timer = setInterval(() => {
          const now = new Date().getTime();
          const targetDate = new Date(currentHellobar.countdownDate).getTime();
          const difference = targetDate - now;

          if (difference > 0) {
            const days = Math.floor(difference / (1000 * 60 * 60 * 24));
            const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((difference % (1000 * 60)) / 1000);

            setTimeLeft({ days, hours, minutes, seconds });
          } else {
            clearInterval(timer);
            setTimeLeft(null);
          }
        }, 1000);

        return () => clearInterval(timer);
      } else {
        setTimeLeft(null);
      }
    }
  }, [hellobars, currentIndex]);

  const handleClose = () => {
    sessionStorage.setItem('hellobarClosed', 'true');
    setHellobars([]);
    if (onClose) {
      onClose();
    }
  };

  if (!hellobars?.length) return null;

  const currentHellobar = hellobars[currentIndex];

  const renderCountdown = () => {
    if (timeLeft === null) {
      return <span>{currentHellobar.messageAfterCountDown}</span>;
    }
    return (
      <>
        <span className="bg-black/10 px-[6px] py-1 rounded-sm">
          {timeLeft.days}D : {timeLeft.hours}H : {timeLeft.minutes}M : {timeLeft.seconds}S
        </span>
      </>
    );
  };

  return (
    <div className="w-full text-[var(--q3-neutral-default_inverted)] bg-[var(--q3-rose-normal)] rounded-xl flex flex-row gap-4 items-center p-4 mb-6 mx-4 lg:mx-0">
      <div className="flex flex-col gap-3 w-full">
        {currentHellobar?.isTimerEnabled && <p>{renderCountdown()}</p>}
        <p>{currentHellobar.message}</p>
      </div>
      {currentHellobar?.isButtonEnabled && (
        <Button
          className="bg-[var(--q3-surface-default)] text-[var(--q3-neutral-default)] hover:scale-100 hover:bg-[var(--q3-surface-dimmer)] hover:text-[var(--q3-neutral-default)]"
          onClick={() => {
            window.open(currentHellobar.url, '_blank');
          }}
        >
          {currentHellobar?.buttonText}
        </Button>
      )}
      {currentHellobar?.showCloseButton && <XIcon className="cursor-pointer" weight="bold" onClick={handleClose} />}
    </div>
  );
};

export default Banner;
